import { render, staticRenderFns } from "./NavItem.vue?vue&type=template&id=59701cfe&scoped=true"
import script from "./NavItem.vue?vue&type=script&lang=js"
export * from "./NavItem.vue?vue&type=script&lang=js"
import style0 from "./NavItem.vue?vue&type=style&index=0&id=59701cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59701cfe",
  null
  
)

export default component.exports